import { useRoutes } from "react-router-dom";
import MainPage from "./pages/MainPage";
import CreateNewPostPage from "./pages/CreateNewPostPage";
import PostListingPage from "./pages/PostListingPage";
import PostDetailPage from "./pages/PostDetailPage";
import PostFailurePage from "./pages/PostFailurePage";
import PostSuccessPage from "./pages/PostSuccessPage";
import PastRequestsDetailPage from "./pages/PastRequestsDetailPage";
import SelectMallPage from "./pages/SelectMallPage";
import LoginPage from "./pages/LoginPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentFinal from "./pages/PaymentFinal";
import PackageSummaryPage from "./pages/PackageSummaryPage";
import CodeProcessPage from "./pages/CodeProcessPage";
import CodeFormPage from "./pages/CodeFormPage";
import ProcessByCodePage from "./pages/ProcessByCodePage";

export default function Router() {
  const routes = useRoutes([
    { path: "/", element: <PostListingPage /> },
    { path: "/*", element: <PostListingPage /> },
    { path: "create-new", element: <CreateNewPostPage /> },
    { path: "payment", element: <PaymentPage /> },
    { path: "payment-final", element: <PaymentFinal /> },
    { path: "create-request", element: <MainPage /> },
    { path: "post-details", element: <PostDetailPage /> },
    { path: "post-details/:index", element: <PostDetailPage /> },
    { path: "past-request-details", element: <PastRequestsDetailPage /> },
    { path: "post-success", element: <PostSuccessPage /> },
    { path: "post-failure", element: <PostFailurePage /> },
    { path: "select-mall", element: <SelectMallPage /> },
    { path: "package-summary", element: <PackageSummaryPage /> },
    { path: "login", element: <LoginPage /> },
    { path: "code-process", element: <CodeProcessPage /> },
    { path: "code-form", element: <CodeFormPage /> },
    { path: "process-by-code", element: <ProcessByCodePage /> },
  ]);

  return routes;
}
